import { ReactNode } from "react";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../components/fonts/font-props";
import { IMoneyDto } from "../../rma-types";
import RmaNotZeroMoneyAmount from "../rma-not-zero-money-amount/rma-not-zero-money-amount";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IProps {
    refundAdjustmentMoneyDto: IMoneyDto;
    color?: FONT_COLOR;
    tooltipContent?: ReactNode;
    amountFontVariant?: FONT_VARIANT | FONT_VARIANT[];
    useColon?: boolean;
}

const ItemBalanceRefundAdjustment: React.FC<IProps> = ({ 
    refundAdjustmentMoneyDto, 
    color, 
    tooltipContent,
    amountFontVariant,
    useColon,
 }) => {
    const rmaCardScope = 'dashboard-returns-rma-card';
    const { getTranslation } = useDashboardTranslation();

    if (refundAdjustmentMoneyDto.amount === 0) {
        return null;
    }

    const title = refundAdjustmentMoneyDto.amount > 0 ? getTranslation('REFUND_BONUS', rmaCardScope) : getTranslation('REDUCED_REFUND', rmaCardScope);
    return (
        <RmaNotZeroMoneyAmount
            title={title}
            moneyDto={refundAdjustmentMoneyDto}
            color={color}
            tooltipContent={tooltipContent}
            amountFontVariant={amountFontVariant}
            useColon={useColon}
            subItem={true}
        />
    );
}

export default ItemBalanceRefundAdjustment;

